<script lang="ts" setup>
    import { gsap } from 'gsap';

    const animateObject1 = ref();
    const animateObject2 = ref();
    const animateObject3 = ref();

    onMounted(() => {
        const animatedObjects = [animateObject1.value, animateObject2.value, animateObject3.value];

        window.addEventListener('mousemove', (e) => {
            const mouseOriginX = e.clientX - window.innerWidth / 2;
            const mouseOriginY = e.clientY - window.innerHeight / 2;
            const mouseDamping = 0.05;

            gsap.to(animatedObjects, {
                x: mouseOriginX * mouseDamping,
                y: mouseOriginY * mouseDamping,
                stagger: 0.05,
                duration: 0.1,
                ease: 'none'
            });
        });
    });
</script>

<template>
    <div class="background">
        <div class="white-gradient"></div>

        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="desktop"
            aria-hidden="true"
        >
            <g clip-path="url(#a)">
                <path
                    fill="#fff"
                    d="M0 0h1920v591H0z"
                />
                <path
                    ref="animateObject1"
                    fill="url(#b)"
                    d="M1701.54 1971.46 545.319 3127.68-637.06 1945.3c-624.2-624.2-622.96-1637.463 2.761-2263.188L521.918-1474.1 1704.3-291.726c624.2 624.2 622.96 1637.466-2.76 2263.186Z"
                    opacity=".75"
                />
                <path
                    ref="animateObject2"
                    fill="url(#c)"
                    d="M1348.95 2240.05 232.419 2451.72 38.43 1428.47C-63.98 888.281 342.841 357.504 947.09 242.95L2063.62 31.276l193.99 1023.244c102.41 540.19-304.41 1070.97-908.66 1185.53Z"
                    opacity=".6"
                />
                <path
                    ref="animateObject3"
                    fill="url(#d)"
                    d="m2270.71 407.617 187.77 942.263-863.39 172.06c-455.81 90.84-907.692-248.91-1009.314-758.854L397.999-179.182l863.401-172.06c455.8-90.833 907.68 248.919 1009.31 758.859Z"
                    opacity=".6"
                />
            </g>
            <defs>
                <linearGradient
                    id="b"
                    x1="362.804"
                    x2="781.618"
                    y1="2579.28"
                    y2="180.817"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop
                        offset=".05"
                        stop-color="#FF9800"
                    />
                    <stop
                        offset=".945"
                        stop-color="#2594A8"
                    />
                </linearGradient>
                <linearGradient
                    id="c"
                    x1="349.123"
                    x2="1420.4"
                    y1="2101.96"
                    y2="876.753"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop
                        offset=".05"
                        stop-color="#FF9800"
                    />
                    <stop
                        offset=".945"
                        stop-color="#2594A8"
                    />
                </linearGradient>
                <linearGradient
                    id="d"
                    x1="2161.91"
                    x2="1117.62"
                    y1="1253.98"
                    y2="358.117"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop
                        offset=".05"
                        stop-color="#FF9800"
                    />
                    <stop
                        offset=".945"
                        stop-color="#2594A8"
                    />
                </linearGradient>
            </defs>
        </svg>

        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="mobile"
            viewBox="0 0 520 591"
            aria-hidden="true"
        >
            <g clip-path="url(#mobile-a)">
                <path
                    fill="#fff"
                    d="M0 0h520v591H0z"
                />
                <path
                    fill="url(#mobile-b)"
                    d="M1631.54 1961.46 475.319 3117.68-707.06 1935.3c-624.2-624.2-622.96-1637.463 2.761-2263.188L451.918-1484.1 1634.3-301.726c624.2 624.2 622.96 1637.466-2.76 2263.186Z"
                    opacity=".75"
                />
                <path
                    fill="url(#mobile-c)"
                    d="m968.953 2080.05-1116.534 211.67-193.989-1023.25C-443.98 728.281-37.16 197.504 567.09 82.95l1116.53-211.674 193.99 1023.247C1980.02 1434.72 1573.2 1965.49 968.953 2080.05Z"
                    opacity=".6"
                />
                <path
                    fill="url(#mobile-d)"
                    d="m2170.71 407.617 187.77 942.263-863.39 172.06c-455.81 90.84-907.692-248.91-1009.314-758.854L297.999-179.182l863.401-172.06c455.8-90.833 907.68 248.919 1009.31 758.859Z"
                    opacity=".6"
                />
            </g>
            <defs>
                <linearGradient
                    id="mobile-b"
                    x1="292.804"
                    x2="711.618"
                    y1="2569.28"
                    y2="170.817"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop
                        offset=".05"
                        stop-color="#FF9800"
                    />
                    <stop
                        offset=".945"
                        stop-color="#2594A8"
                    />
                </linearGradient>
                <linearGradient
                    id="mobile-c"
                    x1="-30.877"
                    x2="1040.4"
                    y1="1941.96"
                    y2="716.753"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop
                        offset=".05"
                        stop-color="#FF9800"
                    />
                    <stop
                        offset=".945"
                        stop-color="#2594A8"
                    />
                </linearGradient>
                <linearGradient
                    id="mobile-d"
                    x1="2061.91"
                    x2="1017.62"
                    y1="1253.98"
                    y2="358.117"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop
                        offset=".05"
                        stop-color="#FF9800"
                    />
                    <stop
                        offset=".945"
                        stop-color="#2594A8"
                    />
                </linearGradient>
            </defs>
        </svg>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/hero-section/hero-background.scss';
</style>
